import React from 'react'
import {
  Grid,
} from '@material-ui/core'

function ReviewIframe() {
  return (
    <Grid container spacing={ 2 } justify="flex-start">
      <Grid item xs={ 12 }>
        <iframe
          width="100%"
          height="720px"
          src="https://forms.office.com/Pages/ResponsePage.aspx?id=y9jP-aXEd0a2XTFQ3aMQyfRxsW5djIBBvLPobJWjCvZUOTdaVTVRUVFUSDdFT1ZPOVEzR00wNzFDNi4u&embed=true"
          frameBorder="0"
          marginWidth="0"
          marginHeight="0"
          style={ { border: 'none', maxWidth: '100%', maxHeight: '100vh' } }
          allowFullScreen
          webkitallowfullscreen
          mozallowfullscreen
          msallowfullscreen
        />
      </Grid>
    </Grid>
  )
}

export default ReviewIframe
